// Footer.tsx
import React from "react";
import { Typography, Link } from "@mui/material";
import { Facebook, YouTube, PlayArrow, Apple } from "@mui/icons-material";
import X from "@mui/icons-material/X";
import { CircularButton } from "./AccountActions";
import ReactRouterLink from "./ReactRouterLink";

const Footer: React.FC = () => {
  const socialMediaIcons = [
    {
      icon: <Facebook style={{ color: "#333" }} />,
      onClick: () => {
        window.open("https://www.facebook.com/fiddlepiddle", "_blank");
      },
    },
    {
      icon: <X style={{ color: "#333" }} />,
      onClick: () => {
        window.open("https://x.com/PiddleFiddle", "_blank");
      },
    },
    {
      icon: <YouTube style={{ color: "#333" }} />,
      onClick: () => {
        window.open("https://www.youtube.com/@fiddlepiddle2312", "_blank");
      },
    },
    {
      icon: <PlayArrow style={{ color: "#333" }} />,
      onClick: () => {
        window.open(
          "https://play.google.com/store/apps/details?id=com.alaaclips.fiddlepiddle",
          "_blank"
        );
      },
    },
    {
      icon: <Apple style={{ color: "#333" }} />,
      onClick: () => {
        window.open(
          "https://apps.apple.com/us/app/fiddlepiddle/id1597349309?platform=iphone",
          "_blank"
        );
      },
    },
  ];

  const renderSocialMediaIcons = () => (
    <div
      style={{
        display: "flex",
        gap: "10px",
        margin: "10px 0",
        justifyContent: "center",
      }}
    >
      {socialMediaIcons.map((item, index) => (
        <CircularButton key={index} color="inherit" onClick={item.onClick}>
          {item.icon}
        </CircularButton>
      ))}
    </div>
  );

  const currentYear = new Date().getFullYear();

  return (
    <>
      {renderSocialMediaIcons()}
      <div>
        <Typography
          variant="caption"
          style={{
            marginTop: "10px",
            textAlign: "center",
            color: "grey",
          }}
        >
          <div
            style={{
              marginBottom: "10px",
              color: "grey",
            }}
          >
            <ReactRouterLink
              to="/blog/about-fiddlepiddle-com"
              linkElement="About Us"
              style={{ color: "#e78758" }}
            />
            {" | "}
            <ReactRouterLink
              to="/blog/start-selling-on-fiddlepiddlecom"
              linkElement="Sell Your Toys"
              style={{ color: "#e78758" }}
            />
            {" | "}
            <ReactRouterLink
              to="/blog/our-protection-guarantee"
              linkElement="Our Guarantee"
              style={{ color: "#e78758" }}
            />
            {" | "}
            <ReactRouterLink
              to="/blog"
              linkElement="Blog"
              style={{ color: "#e78758" }}
            />
          </div>
          <div>
            © {currentYear}{" "}
            <img
              src="/usa.png"
              alt="USA"
              style={{ height: "14px", verticalAlign: "text-bottom" }}
            />{" "}
            FiddlePiddle - Buy & Sell Toys
          </div>
          <div>
            <ReactRouterLink
              to="/blog/support"
              linkElement="Support"
              style={{ color: "grey" }}
            />
            {" | "}
            <ReactRouterLink
              to="/blog/privacy"
              linkElement="Privacy Policy"
              style={{ color: "grey" }}
            />
            {" | "}
            <ReactRouterLink
              to="/blog/terms"
              linkElement="Terms of Service"
              style={{ color: "grey" }}
            />
          </div>
        </Typography>
      </div>
    </>
  );
};

export default Footer;
